import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LorenUserSettingsComponent} from './components/loren-user-settings/loren-user-settings.component';

const routes: Routes = [
    {
        path: '',
        component: LorenUserSettingsComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LorenUserSettingsRoutingModule {
}
